import { useDispatch } from 'react-redux';
import deleteDialogSlice from './deleteDialogSlice';
import { useCallback } from 'react';

export default function useDeleteDialog() {
  const dispatch = useDispatch();

  const openDialog = useCallback(
    (onConfirm: (input: string) => void) => {
      dispatch(deleteDialogSlice.actions.open(onConfirm));
    },
    [dispatch],
  );

  const closeDialog = useCallback(() => {
    // @ts-ignore
    dispatch(deleteDialogSlice.actions.close());
  }, [dispatch]);

  return { openDialog, closeDialog };
}
